const ReportCategory = {
  addReportCategory: {
    url: "/report-category",
    method: "POST",
  },
  getReportCategories: {
    url: "/report-category",
    method: "GET",
  },
  getReportCategory: (reportCategoryId) => ({
    url: `/report-category/${reportCategoryId}`,
    method: "GET",
  }),
  updateReportCategory: (reportCategoryId) => ({
    url: `/report-category/${reportCategoryId}`,
    method: "PUT",
  }),
  deleteReportCategory: (reportCategoryId) => ({
    url: `/report-category/${reportCategoryId}`,
    method: "DELETE",
  }),
};
export default ReportCategory;
